<template>
    <div class="custom-work-confirmation">
        <CustomWorkExecutivesList :executives="executives" />
        <div class="active-pane">
            <div class="invoice">
                <table>
                    <thead>
                        <tr>
                            <th class="package">Package</th>
                            <th class="quantity">Quantity</th>
                            <th class="price">Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="package">{{ packageName }}</td>
                            <td class="quantity">{{ quantity }}</td>
                            <td class="price">{{ formats.currency(packagePrice) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="total">
                            <td class="price" colspan="3">{{ formats.currency(totalPrice) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <HintBox type="info"> Custom orders are embargoed for 30-days from the date of client delivery. </HintBox>
        </div>
    </div>
</template>
<script>
import { formatCurrency } from '@/utils/format'

import CustomWorkExecutivesList from './CustomWorkExecutivesList.vue'

import HintBox from '@/components/shared/hint-box'

export default {
    components: {
        CustomWorkExecutivesList,
        HintBox,
    },
    data() {
        return {
            formats: {
                currency(value) {
                    return formatCurrency(value, { maximumFractionDigits: 0 })
                },
            },
        }
    },
    props: {
        executives: {
            type: Array,
            required: true,
        },
        packageName: {
            type: String,
            required: true,
        },
        packagePrice: {
            type: Number,
            required: true,
        },
        quantity: {
            type: Number,
            required: true,
        },
    },
    computed: {
        totalPrice() {
            return this.quantity * this.packagePrice
        },
    },
}
</script>
<style>
.custom-work-confirmation {
    display: flex;
    gap: 40px;
    align-items: stretch;
    justify-items: stretch;

    & > * {
        width: 50%;
    }

    .custom-work-executives-list {
        flex-grow: 1;
        height: 100%;
        overflow-y: auto;
    }

    .active-pane {
        display: flex;
        flex-direction: column;
        height: 100%;

        .invoice {
            flex-grow: 1;
            height: 1%;

            td,
            th {
                padding: 4px 8px;
            }

            .package {
                text-align: left;
            }

            .price {
                text-align: right;
            }

            .quantity {
                text-align: center;
            }

            .total {
                border-top: 1px dotted black;
            }
        }
    }
}
</style>
